<template>
  <div class="app-container">
    <!-- 主体内容区域 -->
    <div class="main-content">
      <!-- 左侧边栏 - JumpModal 页面时隐藏 -->
      <div v-if="!isJumpModalPage" class="left-sidebar" :class="{ 'collapsed': isCollapse }">
        <!-- 折叠按钮 -->
        <div class="collapse-btn" @click="toggleCollapse">
          <i :class="isCollapse ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'"></i>
        </div>

        <!-- 用户信息区域 -->
        <div class="user-section">
          <el-dropdown
            ref="userDropdown"
            :visible-arrow="false"
            placement="bottom"
            trigger="click"
            @command="handleUserCommand"
          >
            <el-avatar
              :size="isCollapse ? 40 : 60"
              :src="userAvatar"
              icon="el-icon-user-solid"
              class="user-avatar"
              style="cursor: pointer;"
            ></el-avatar>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">
                <i class="el-icon-user"></i>
                个人详情
              </el-dropdown-item>
              <el-dropdown-item command="logout" divided>
                <i class="el-icon-switch-button"></i>
                退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <div class="user-info" v-if="!isCollapse">
            <div class="user-role primary">{{ tenantName || '超级管理员' }}</div>
            <div class="user-role secondary">{{ userInfo.realname || '系统管理员' }}</div>
          </div>
        </div>

        <!-- 菜单区域 -->
        <div class="menu-section">
          <div class="menu-item" :class="{ active: activeMenuItem === 'medicalRecord' }" @click="handleMenuItemClick('medicalRecord')">
            <i class="el-icon-document"></i>
            <span v-if="!isCollapse">门诊病历</span>
          </div>
          <div class="menu-item" :class="{ active: activeMenuItem === 'inpatientRecord' }" @click="handleMenuItemClick('inpatientRecord')">
            <i class="el-icon-files"></i>
            <span v-if="!isCollapse">住院病历</span>
          </div>
        </div>

        <!-- 应用标题 -->
<!--        <div class="app-title" v-if="!isCollapse" @click="goToHome">-->
<!--          岗医通-->
<!--        </div>-->
      </div>

      <!-- 右侧内容区域 -->
      <div class="right-content" :class="{ 'expanded': isCollapse || isJumpModalPage }">
        <div class="content-wrapper">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "@/components/header/index.vue";
import Nav from "@/components/navMenu/index.vue";
import Watermark from "@/components/watermark/index.vue";
import { mapState, mapMutations } from "vuex";
import {getToken,getLoginuserId,saveDepoartmentId,getDepoartmentId} from "@/services/newdeal"
import {getLoginUserDepart,getLoginUserSelf,getLoginUserHospital,getLoginUserDepoartment,getLoginuserTodayBooking } from "@/services/newcall"
import { getList_patient } from "@/services/newstep2"
import { getAi_Reference,postAi_Record,getProfessional_Self,setProfessional_Self,addConversation_Record } from "@/services/newcall"

export default {
  components: {
    Nav,
    Header,
    Watermark
  },

  async mounted() {
    /* 根据权限初始化导航 迁移到了store*/
    // this.navData = JSON.parse(JSON.stringify(this.navList));
    // this.filterFun(this.navData, this.roleList);
    // this.$store.commit("updataFilterNavList", this.navData);
    /* 初始化导航高亮 */
    // this.findFun(
    //   this.filterNavList,
    //   window.location.hash.substring(1, window.location.hash.length)
    // );
    // if (!this.active) {
    //   this.$router.push({ name: "Errow" });
    //   return;
    // }
  },
  created() {
    this.watermarkStr = this.userInfo.title + "-" + this.userInfo.alias_name;
    // 根据当前路由初始化左侧菜单选中状态（解决刷新时高亮错误）
    this.updateActiveMenuByRoute(this.$route);
  },
  data() {
    return {
      watermarkStr: "",
      isCollapse: true, //是否折叠导航栏，默认收起
      routerName: "",
      roleList: [], //权限
      userAvatar: require('@/image/user.png'), // 默认头像
      activeMenuItem: 'medicalRecord' // 当前选中的菜单项
    };
  },
  computed: {
    ...mapState(["userInfo", "filterNavList", "active"]),
    // 获取租户名称
    tenantName() {
      return this.userInfo?.tenantName || '';
    },
    // 判断是否是 JumpModal 页面
    isJumpModalPage() {
      return this.$route.name === 'JumpModal';
    }
  },
  watch: {
    // 监听路由变化，更新菜单选中状态
    '$route'(to) {
      this.updateActiveMenuByRoute(to);
    }
  },
  methods: {
    // 根据路由设置左侧菜单选中项
    updateActiveMenuByRoute(route) {
      if (!route) return;
      if (route.name === 'InpatientRecord') {
        this.activeMenuItem = 'inpatientRecord';
      } else if (route.name === 'ConsultationControl') {
        this.activeMenuItem = 'medicalRecord';
      }
    },
    goToHome() {
      // 返回主页
      this.$router.push({ name: "ConsultationControl" });
    },

    // 处理用户菜单命令
    handleUserCommand(command) {
      switch (command) {
        case 'profile':
          this.$router.push({ name: 'PersonCenter' });
          break;
        case 'logout':
          this.logout();
          break;
      }
    },

    // 退出登录
    logout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 清除本地存储
        localStorage.removeItem('storeToken');
        localStorage.removeItem('loginTenantId');
        // 跳转到登录页
        this.$router.push({ name: 'Login' });
        this.$message.success('已退出登录');
      }).catch(() => {
        // 用户取消
      });
    },
    clickNav(item) {
      // this.active = item.id;
      this.updataActive(item.id);
      this.routerName = item.routerName;
      this.$router.push({ name: item.routerName });
    },
    // 切换侧边栏折叠状态
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    // 处理菜单项点击，避免重复导航报错
    handleMenuItemClick(menuItem) {
      this.activeMenuItem = menuItem;

      let targetRoute = null;
      if (menuItem === 'medicalRecord') {
        // 门诊病历 -> 问诊中心
        targetRoute = { name: 'ConsultationControl' };
      } else if (menuItem === 'inpatientRecord') {
        // 住院病历
        targetRoute = { name: 'InpatientRecord' };
      }

      if (!targetRoute) return;

      // 已经在当前路由时不再重复跳转，避免 NavigationDuplicated 报错
      if (this.$route.name === targetRoute.name) {
        return;
      }

      this.$router.push(targetRoute);
    },
    test1(){
      let token = getToken();
      let loginuserId = getLoginuserId();
      console.log(token);
      console.log(loginuserId);

    },
    test2(){
      getLoginUserDepart().then(res => {
        console.log("专业人员信息",res.result.departmentId);

        saveDepoartmentId(res.result.departmentId);


        console.log(res.result);
      });

    },
    test3(){
      console.log("test3");
      getLoginUserSelf().then(res => {
        console.log("content ======")
        console.log(res.result[0].specialtyConsultationTemplate);
      });

    },
    test40(){
      getLoginUserHospital().then(res => {
        console.log(res.result);
      });
      getLoginUserDepoartment().then(res => {
        console.log(res.result);
      });
    },
    test4(){
      getLoginuserTodayBooking().then(res => {
        console.log(res.result);
        //currentStage  //状态
        //medmstrId   //用户编号
        let list_patient = getList_patient(res.result.records);
        console.log("list_patient,所有的患者列表");
        console.log(list_patient);
      });
    },
    test5(){
      console.log("test5");
    },
    test6_1(){
      let pd= addConversation_Record({id:100});

      console.log(pd);




    },
    test6(){
    // 获取历史对话记录
      console.log("test6");
    },
    test7(){
      console.log("test7");
      postAi_Record("").then(res => {
        console.log(res.result);
      });

    },
    test8(){
      console.log("test8");
    },
    test8_read(){
       this.test3();
    },
    test8_write(){
      console.log("test8");
    },

    test9(){
      //AI 引用
      console.log("test9");
      getAi_Reference("","").then(res => {
        console.log(res.result);
      });
    },
    /*  找到导航 id */
    // findFun(navData, path) {
    //   for (let index = 0; index < navData.length; index++) {
    //     if (navData[index]?.path === path) {
    //       this.active = navData[index]?.id;
    //     }
    //     if (
    //       navData[index]?.children &&
    //       navData[index]?.children.length > 0 &&
    //       navData[index]?.path !== path
    //     ) {
    //       this.findFun(navData[index].children, path);
    //     }
    //   }
    // },

    /* 筛选全量导航 */
    // filterFun(navData, roleList) {
    //   for (var index = navData.length - 1; index >= 0; index--) {
    //     if (
    //       navData[index]?.children &&
    //       navData[index]?.children.length > 0 &&
    //       roleList?.indexOf(navData[index].id) >= 0
    //     ) {
    //       this.filterFun(navData[index].children);
    //     }
    //     if (roleList?.indexOf(navData[index].id) < 0) {
    //       navData.splice(index, 1);
    //     }
    //   }
    // },
  }
};
</script>
<style lang="less" scoped>
.app-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
  overflow: hidden;
}

/* 顶部导航栏 */
.top-header {
  height: 60px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;

  .header-left {
    display: flex;
    align-items: center;

    .project-title {
      font-size: 18px;
      font-weight: 600;
      color: #4169e1;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: color 0.3s ease;
      width: 100%;

      &:hover {
        color: #4169e1;
      }
    }
  }

  .header-right {
    display: flex;
    align-items: center;

    .user-profile {
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 8px 12px;
      border-radius: 6px;
      transition: background-color 0.3s ease;

      &:hover {
        background-color: #f5f5f5;
      }

      .user-avatar {
        margin-right: 8px;
      }

      .user-name {
        margin-right: 6px;
        font-size: 14px;
        color: #333;
      }

      i {
        font-size: 12px;
        color: #999;
      }
    }
  }
}

/* 主体内容区域 */
.main-content {
  flex: 1;
  display: flex;
  height: 100vh;
  overflow: hidden;
}

/* 左侧边栏 */
.left-sidebar {
  width: 280px;
  background: linear-gradient(to bottom right, #6b9df5, #4169e1);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1rem;
  position: relative;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  transition: width 0.3s ease;
  overflow-y: auto;
  overflow-x: hidden;

  &.collapsed {
    width: 80px;
    padding: 0 0.5rem;

    .user-section {
      margin-top: 3rem; // 为折叠按钮留出空间
      .user-info {
        display: none;
      }
    }

    .menu-section {
      .menu-item {
        justify-content: center;
        padding: 0.75rem 0;
        width: 100%;

        i {
          margin-right: 0;
          font-size: 1.3rem;
        }

        span {
          display: none;
        }
      }
    }

    .app-title {
      display: none;
    }
  }

  /* 折叠按钮 */
  .collapse-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 32px;
    height: 32px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    color: white;
    z-index: 10;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
      transform: scale(1.1);
    }

    i {
      font-size: 14px;
    }
  }

  &.collapsed .collapse-btn {
    right: 10px; // 收起时调整位置，避免与头像重合
  }

  .user-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: white;
    margin-top: 1rem;
    padding-top: 1rem;

    .user-avatar {
      border: 3px solid rgba(255, 255, 255, 0.3);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
      margin-bottom: 1rem;
    }

    .user-info {
      margin-bottom: 1rem;
      width: 100%;

      .user-role {
        margin-bottom: 0.5rem;
        font-weight: 500;

        &.primary {
          font-size: 1.2rem;
          font-weight: 600;
        }

        &.secondary {
          font-size: 1rem;
          opacity: 0.9;
          margin-bottom: 1rem;
        }
      }

      .menu-item {
        width: calc(100% + 2rem); // 扩展到两侧，抵消左右padding
        margin-left: -1rem;
        margin-right: -1rem;
        padding: 0.75rem 1rem;
        display: flex;
        align-items: center;
        color: white;
        cursor: pointer;
        transition: all 0.3s ease;
        font-size: 0.95rem;
        font-weight: 500;
        margin-top: 0.5rem;
        background: transparent; // 默认无背景
        position: relative;
        border-radius: 0; // 默认无圆角

        i {
          margin-right: 0.5rem;
          font-size: 1.1rem;
          transition: color 0.3s ease;
        }

        span {
          flex: 1;
        }

        &:hover {
          background: rgba(255, 255, 255, 0.1);
        }

        &.active {
          background: white;
          color: #4169e1;
          border-radius: 0.5rem; // 选中时添加圆角

          i {
            color: #4169e1;
          }
        }
      }
    }
  }

  // 独立的菜单区域样式
  .menu-section {
    width: 100%;
    margin-top: 1rem;
    padding: 0 0 0 1rem; // 只保留左边距，移除右边距
    margin-right: -1rem;

    .menu-item {
      width: calc(100% + 1rem); // 只需要延伸右边 1rem 来抵消 left-sidebar 的 padding-right
      padding: 0.75rem 1rem;
      display: flex;
      align-items: center;
      color: white;
      cursor: pointer;
      transition: all 0.3s ease;
      font-size: 0.95rem;
      font-weight: 500;
      margin-top: 0;
      margin-bottom: 0.5rem;
      background: transparent;
      position: relative;
      border-radius: 0;

      i {
        margin-right: 0.5rem;
        font-size: 1.1rem;
        transition: color 0.3s ease;
      }

      span {
        flex: 1;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.1);
      }

      &.active {
        background: white;
        color: #4169e1;
        border-radius: 0.5rem; // 选中时添加圆角

        i {
          color: #4169e1;
        }
      }

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &.collapsed .menu-section {
    padding: 0;
    margin-right: 0;
    margin-top: 1rem;

    .menu-item {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
      border-radius: 0.5rem;
      background: transparent;
      padding: 0.75rem;

      &:hover {
        background: rgba(255, 255, 255, 0.08);
      }

      &.active {
        background: transparent;
        color: white;

        i {
          color: white;
          transform: scale(1.1);
        }
      }
    }
  }

  .app-title {
    font-size: 1.1rem;
    font-weight: 500;
    text-align: center;
    line-height: 1.4;
    color: white;
    opacity: 0.9;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      opacity: 1;
      transform: scale(1.02);
    }
  }
}

/* 右侧内容区域 */
.right-content {
  flex: 1;
  background: #f5f5f5;
  transition: margin-left 0.3s ease;

  &.expanded {
    margin-left: 0;
  }

  .content-wrapper {
    width: 100%;
    height: 100%;
    border-radius: 0;
    box-sizing: border-box;
    padding: 10px;
    background: #f2f2f7;
    margin: 0;
    box-shadow: none;
    overflow: hidden;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .top-header {
    padding: 0 15px;

    .header-left .project-title {
      font-size: 16px;
    }

    .header-right .user-profile {
      .user-name {
        display: none;
      }
    }
  }

  .left-sidebar {
    width: 200px;
    padding: 1rem 0.5rem;

    &.collapsed {
      width: 60px;
    }

    .user-section {
      .user-avatar {
        width: 50px !important;
        height: 50px !important;
      }

      .user-info .user-role.primary {
        font-size: 1rem;
      }

      .app-title {
        font-size: 0.9rem;
      }
    }
  }

  .right-content .content-wrapper {
    margin: 5px;
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .left-sidebar {
    position: fixed;
    left: -280px;
    top: 0;
    height: 100vh;
    z-index: 999;
    transition: left 0.3s ease;

    &.collapsed {
      left: 0;
      width: 280px;
    }
  }

  .right-content {
    margin-left: 0 !important;
  }
}
</style>
